<template>
	<div class="us-item" :class="{ 'us-item-selected': selected }">
		<sym-icon v-if="item.icon" :name="item.icon" class="us-avatar"></sym-icon>
		<sym-icon v-else name="empty-18" class="us-avatar"></sym-icon>
		<div v-if="item.name">
			<span class='mailSuggName'>{{ item.name }}</span>
			<span class='mailSuggEmail'>{{ joinedAddresses }}</span>
		</div>
		<div v-else>
			<span class='mailSuggName'>{{ item.mails[0].address }}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import {SuggestedMail} from "@t/fd/editor/MailSelect.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {computed} from "vue";

const props = defineProps<{
	item: SuggestedMail,
	selected: boolean
}>();

const joinedAddresses = computed<string>(() => {
	const adrs:string[] = [];
	for (let a of props.item.mails) {
		adrs.push(a.address);
	}
	let joined = adrs.join(", ");
	return joined.length <= 80 ? joined : joined.substring(0, 80)+"…";
});
</script>

<style>

.fd-mail-select-drop {
	& > .us-item {
		padding: 4px 8px 4px 30px;
		position: relative;
		cursor: pointer;

		&.us-item-selected {
			background-color: var(--drop-bg-selection);
			color: var(--drop-fg-selection);
			--link-fg: var(--drop-fg-selection);
		}

		& > .us-avatar {
			position: absolute;
			width: 18px;
			height: 18px;
			border-radius: 50%;
			top: 4px;
			left: 8px;
		}
	}
}
</style>